import { useEffect } from 'react';

import { useTenantSettings } from '@/features/tenant-settings/hooks/useTenantSettings';
import { anonymizeUser, identifyUser, initFullStory } from '@/lib/fullstory';
import { useAuthStore } from '@/stores/useAuthStore';

interface FullStoryProviderProps {
  children: React.ReactNode;
}

export const FullStoryProvider: React.FC<FullStoryProviderProps> = ({ children }) => {
  const user = useAuthStore((state) => state.user);
  const { settings } = useTenantSettings();

  useEffect(() => {
    initFullStory(settings.FULLSTORY_ENABLED === 'true');
  }, [settings.FULLSTORY_ENABLED]);

  useEffect(() => {
    if (user !== null) {
      identifyUser(user);
    } else {
      anonymizeUser();
    }
  }, [user]);

  return <>{children}</>;
};
